import styled from 'styled-components';
import { Alert } from 'antd';

interface StyledAlertProps {
  variant?: 'info' | 'success' | 'warning' | 'error';
}

export const StyledAlert = styled(Alert)<StyledAlertProps>`
  border-radius: 6px;
  padding: 12px 16px;

  /* Info variant styles */
  &.ant-alert-info {
    background-color: ${({ variant, theme }) =>
      variant === 'info' || !variant ? theme.palette.blue[50] : 'inherit'};
    border: 1px solid
      ${({ variant, theme }) =>
        variant === 'info' || !variant
          ? theme.palette.blue[500]
          : 'inherit'};
  }

  /* Success variant styles */
  &.ant-alert-success {
    background-color: ${({ variant }) =>
      variant === 'success' ? '#f6ffed' : 'inherit'};
    border: 1px solid
      ${({ variant }) => (variant === 'success' ? '#b7eb8f' : 'inherit')};
  }

  /* Warning variant styles */
  &.ant-alert-warning {
    background-color: ${({ variant, theme }) =>
      variant === 'warning' ? theme.palette.white : 'inherit'};
    border: 1px solid
      ${({ variant, theme }) =>
        variant === 'warning' ? theme.palette.yellow[500] : 'inherit'};
    align-items: start;
  }

  /* Error variant styles */
  &.ant-alert-error {
    background-color: ${({ variant }) =>
      variant === 'error' ? '#fff2f0' : 'inherit'};
    border: 1px solid
      ${({ variant }) => (variant === 'error' ? '#ffccc7' : 'inherit')};
  }

  /* Icon styling */
  .ant-alert-icon {
    font-size: 16px;
    line-height: 1.5;
    color: ${({ theme, variant }) =>
      variant === 'info'
        ? theme.palette.blue[500]
        : variant === 'warning'
          ? theme.palette.yellow[500]
          : theme.palette.text.primary};
  }

  /* Message styling */
  .ant-alert-message {
    color: ${({ theme, variant }) =>
      variant === 'info'
        ? theme.palette.blue[500]
        : variant === 'warning'
          ? theme.palette.yellow[500]
          : variant === 'success'
            ? theme.palette.success.main
            : variant === 'error'
              ? theme.palette.red.ERROR500
              : theme.palette.text.primary};
    font-weight: ${({ theme }) => theme.font.weight.medium};
  }

  /* Description styling */
  .ant-alert-description {
    color: ${({ theme }) => theme.palette.text.secondary};
    font-size: ${({ theme }) => theme.font.size.base};
    line-height: 1.5;
  }

  /* Close button styling */
  .ant-alert-close-icon {
    color: ${({ theme }) => theme.palette.text.secondary};
    font-size: 14px;

    &:hover {
      color: ${({ theme }) => theme.palette.text.primary};
    }
  }
`;

export const StyledAlertIconWrapper = styled.div<StyledAlertProps>`
  color: ${({ theme, variant }) =>
    variant === 'info'
      ? theme.palette.blue[500]
      : theme.palette.secondary.main};
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme, variant }) =>
    variant === 'info'
      ? theme.palette.blue[100]
      : variant === 'warning'
        ? theme.palette.white
        : theme.palette.secondary.main};
  border-radius: 50%;
  border: ${({ variant, theme }) =>
    variant === 'warning' ? `1px solid ${theme.palette.yellow[500]}` : 'none'};
`;
